var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPortlinkLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1971.8 1890.03",
    style: {
      enableBackground: "new 0 0 1971.8 1890.03"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#6590CB;}\n\t.st1{fill:#424A65;}\n\t.st2{fill:#4F5678;}\n\t.st3{fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st4{fill:#595A5A;}\n\t.st5{font-family:'Poppins-Medium';}\n\t.st6{font-size:452.0124px;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1457.13,1150.53c0,0-112.38,289.35-461.89,290.23c-346.86-16.81-499.43-311.14-456.14-459.96 c0,0,57.07-189.96,253.51-124.93c160.6,88.93,47.78,242.89-11.95,243.56c0,0,48.45-52.43-12.61-104.86 s-181.76,121.23-29.86,269.88c-3.54-33.62,49.99-113.26,129.19-107.29s86.72,65.48,88.49,83.18c1.77,17.7-9.29,61.05-50.44,75.21 c0,0,21.68-36.28-7.96-59.73c-29.64-23.45-80.52,0.88-79.19,49.99c1.77,56.19,197.65,108.84,347.97,65.04 C1342.1,1315.44,1427.71,1212.58,1457.13,1150.53z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1108.5,657.66l-92.02,136.27c0,0,132.16,249.8,113.26,486.67C1189.9,1119.56,1198.75,887.73,1108.5,657.66z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1127.96,648.82c0,0,259.26,113.26,362.46,401.5c-39.49,91.22-151.64,250.19-341.44,293.55 C1179.29,1208.04,1242.22,1010.83,1127.96,648.82z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "1435.89,792.6 1435.89,897.46 1372.18,806.61 1372.18,732.43  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "1372.18,732.43 1372.18,806.61 1327.94,760.75 1327.94,732.43  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "1461.11,728.89 1461.11,791.28 1372.18,700.36 1372.18,634.07  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1372.18,634.07v66.29l-78.75,23.67c0,0-23.67-35.25-50.44-54.42L1372.18,634.07z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "1413.77,550.6 1413.77,657.66 1372.63,613.57 1372.18,613.72 1372.18,512.55  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "1372.18,337.79 1372.18,613.72 1330.6,626.25 1330.6,511.66 1353.16,511.66 1353.16,337.79  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 1372.18,
    y1: 614.01,
    x2: 1372.18,
    y2: 613.72
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1107.47,1517.82l-111.34,170.63V1527.4C1055.7,1527.48,1107.47,1517.82,1107.47,1517.82z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M996.12,1527.4v161.04L888.91,1526C928.65,1528.95,951.44,1528.95,996.12,1527.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M874.67,470.8l111.34-168.32v159.32C915.54,461.67,874.67,470.8,874.67,470.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M986.01,461.81V302.48l109.09,174.32C1065.24,470.8,1035.25,464.16,986.01,461.81z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.73,1110.35L247.68,994.28h163.79C408.36,1047.22,419.73,1110.35,419.73,1110.35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M411.47,994.28H247.68l181.46-126.23C419.47,911.62,413.83,935.18,411.47,994.28z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1165.47,499.61c-22.56-11.95-89.81-34.95-183.39-37.94c-351.5,0-570.95,253.68-570.95,549.83 s226.52,534.45,570.95,515.65c306.74,0.96,477.38-163.21,501.25-415.45v-0.29c-37.74,229.61-214.71,366.61-499.42,359.97 c-313.01-2.65-502.55-203.66-502.55-462s195.73-484.8,510.29-517.98C1045.85,487.2,1099.99,485.45,1165.47,499.61"
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 1490.4315 585.1163)",
    className: "st1 st5 st6"
  }, "\xAE"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortlinkLogo);
export default __webpack_public_path__ + "static/media/portlinkLogo.4eee911b22b19ca46fa16a02f46c212a.svg";
export { ForwardRef as ReactComponent };